import { Badge } from '@/components/ui/badge';

interface ThemesListProps {
  themes: string[];
  onThemeClick?: (theme: string) => void;
}

/**
 * Shared component for displaying passage themes as clickable badges
 * Used in both the scriptural context page and the capability modal
 */
export function ThemesList({ themes, onThemeClick }: ThemesListProps) {
  if (!themes || themes.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {themes.map((theme, index) => (
        <Badge
          key={index}
          variant="secondary"
          className={onThemeClick ? "cursor-pointer hover:bg-primary hover:text-primary-foreground transition-colors" : ""}
          onClick={() => onThemeClick?.(theme)}
          title={onThemeClick ? `See all passages with theme: ${theme}` : undefined}
        >
          {theme}
        </Badge>
      ))}
    </div>
  );
}

